import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { testIdConcat } from '@atlassian/jira-navigation-apps-common/src/utils/test-id.tsx';
import { dashboardsDirectoryRoute } from '@atlassian/jira-router-routes-directories-routes/src/dashboardsDirectoryRoute.tsx';
import { useIsAnonymous } from '@atlassian/jira-tenant-context-controller/src/components/is-anonymous/index.tsx';
import { MenuItem } from '../../../../common/ui/menu/item/index.tsx';
import { CreateButton } from './create-button/main.tsx';
import messages from './messages.tsx';
import type { FooterProps } from './types.tsx';

export const Footer = ({ testIdPrefix }: FooterProps) => {
	const { formatMessage } = useIntl();
	const isAnonymous = useIsAnonymous();

	const testId = testIdConcat(testIdPrefix, 'items');
	const dashboardsUrl = '/jira/dashboards';

	return (
		<span data-testid={testId}>
			<MenuItem
				analytics={{
					actionSubjectId: 'dashboardsNavigationMenuItem',
					menuItemId: 'viewAll',
					menuItemType: 'action',
					position: 0,
				}}
				href={dashboardsUrl}
				testId={testIdConcat(testId, 'item-view-all')}
				to={dashboardsDirectoryRoute}
			>
				{formatMessage(messages.viewAll)}
			</MenuItem>
			{!isAnonymous && <CreateButton testId={testIdConcat(testId, 'item-create')} />}
		</span>
	);
};
